import React, {useEffect, useState} from "react";
import FormButton from "../../../../../components/form-button";
import {useTranslation} from "react-i18next";
import CurrencyInput from "react-currency-input-field";
import associateServices from "../../../../../services";
import {Tooltip} from "react-tooltip";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import SvgIcon from "../../../../../components/svg-icon";
import stringHelper from "../../../../../helpers/string-helper";
import CLIPBOARD_HELPER from "../../../../../helpers/clipboard-helpers";
import InformationToast from "../../../../../components/toast/InformationToast";
import {useSelector} from "react-redux";

const AznDeposit = (props) => {

    const [show, setShow] = useState(false)
    const {i18n, t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language
    const {agent} = useSelector(state => state.globalReducer)

    const {type, selectedProvider, method} = props
    const [isValid, setIsValid] = useState(false)
    const [loading, setLoading] = useState(false)
    const [amount, setAmount] = useState('')
    const [bankInfo, setBankInfo] = useState(null)

    const [error, setError] = useState('')


    useEffect(() => {
        associateServices.profile({}).then(res => {
            setError(!res?.data?.name || !res?.data?.surname ? t('general.provide-your-name-surname-to-deposit-withdraw-try') : '')
        })
    }, [])

    useEffect(() => {
        setIsValid(amount >= 1)
    }, [amount, type])


    const [url, setURL] = useState('')
    const getBankInformation = () => {

        if (!selectedProvider?.id)
            return toast(<InformationToast
                icon={'ti-x'}
                title={t(`general.error`)}
                message={t(`payment.please-select-`, 'Please select provider')}
            />)


        const instance = {
            amount,
            type: type === 'Havale' ? 'Transfer' : type,
            provider: selectedProvider?.id
        }


        setLoading(true)
        associateServices.getTransferBankInfo(instance).then(res => {

            if (res?.errors)
                toast.error(t(`api-notifications.${res?.errors}`))


            if (res?.data?.navigate) {

                if (res?.data?.url) {

                    // setURL(res?.data?.url)

                    try {
                        if (agent?.isMobile)
                            window.location.href = res?.data?.url;
                        else
                            window.open(res?.data?.url, '_blank')
                    } catch (e) {
                        window.location.href = res?.data?.url;
                    }
                    // window.open(res?.data?.url, '_blank', 'noopener,noreferrer')
                    setLoading(false)
                }
            } else {
                setBankInfo(res?.data || null)
                setLoading(false)
            }
        })
    }

    const handleCopy = (link) => {
        try {
            CLIPBOARD_HELPER.copy(link || '')
        } catch (e) {

        }
    }


    const handlePaymentDoneButton = () => {
        toast(<InformationToast
            icon={'ti-info-circle'}
            title={t(`general.information`)}
            message={t(`api-notifications.your-deposit-has-been-checking`, 'Your deposit is being checked. Your balance will be updated once the payment is completed.')}
        />)
    }
    return (
        <div className="modal__form">

            {
                url && <>

                    <div
                        className="modal fade show"
                        id="deposit-modal"
                        style={{
                            display: 'block'
                        }}
                    >
                        <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal__content">
                                    <iframe src={url}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

            {
                bankInfo ?
                    <>
                        <div className="form__group modal__wallet-dropdown modal__wallet-dropdown--long width-unset">
                            <label htmlFor="" className="form__label">
                                {t('general.account-no', 'Account No')}
                                <b>*</b>
                            </label>
                            <div className="form__wallet">
                                <input
                                    value={bankInfo?.bankIban}
                                    disabled
                                    type="text" className="form__input"/>


                                <div className="form__actions">
                                    <Tooltip className="tooltip-me" id="copy-tooltip"/>

                                    <button type="button"
                                            data-tooltip-id="copy-tooltip"
                                            data-tooltip-content={'Copy'}
                                            data-tooltip-place="top"
                                            onClick={e => handleCopy(bankInfo?.bankIban)}
                                    >
                                        <SvgIcon id={'copy'}/>

                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="form__group modal__wallet-dropdown modal__wallet-dropdown--long width-unset">
                            <label htmlFor="" className="form__label">
                                {t('general.account-owner', 'Account Owner')}
                                <b>*</b>
                            </label>
                            <div className="form__wallet">
                                <input
                                    value={bankInfo?.accountOwner}
                                    disabled
                                    type="text" className="form__input"/>
                                <div className="form__actions">
                                    <Tooltip className="tooltip-me" id="copy-tooltip"/>

                                    <button type="button"
                                            data-tooltip-id="copy-tooltip"
                                            data-tooltip-content={'Copy'}
                                            data-tooltip-place="top"
                                            onClick={e => handleCopy(bankInfo?.accountOwner)}
                                    >
                                        <SvgIcon id={'copy'}/>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </> :
                    <>


                        {/*<div className="modal__drops">*/}
                        {/*    <div*/}
                        {/*        className="modal__wallet-dropdown modal__wallet-dropdown--double-big width-unset"*/}
                        {/*        show={show}*/}
                        {/*        onToggle={() => setShow(!show)}*/}
                        {/*    >*/}
                        {/*        <div*/}
                        {/*            className="modal__wallet-dropdown-btn"*/}
                        {/*            id="modalWallet0"*/}
                        {/*            aria-expanded={show}*/}
                        {/*        >*/}
                        {/*            Provider {selectedProvider?.name}*/}
                        {/*            <SvgIcon id={'right-down'}/>*/}
                        {/*        </div>*/}

                        {/*    </div>*/}

                        {/*</div>*/}

                        <div className="modal__drops">


                            <div className="modal__wallet-dropdown modal__wallet-dropdown--double-big width-unset">
                                <CurrencyInput
                                    decimalsLimit={2}
                                    className="form__input  "
                                    prefix={'AZN '}
                                    disabled={!selectedProvider || !type}
                                    value={amount}
                                    placeholder={t('general.amount', 'Amount')}
                                    onValueChange={(value) => setAmount(value)}
                                />
                            </div>


                            {
                                method?.id &&
                                <div className="modal__wallet-dropdown modal__wallet-dropdown--double-big width-unset">

                                    <div className="selected-method-wrapper">
                                        <img src={method?.logo_light} alt=""
                                             className={`method-img-selected ${method?.name}`}/>
                                    </div>
                                </div>
                            }


                        </div>

                    </>

            }


            {
                !bankInfo ?
                    <FormButton
                        disabled={!isValid || !type || error}
                        // disabled={true}
                        loading={loading}
                        onClick={getBankInformation}
                        // onClick={null}
                        label={t('general.send-request', 'Send Request')}
                    />
                    :
                    <FormButton
                        onClick={handlePaymentDoneButton}
                        label={t('general.i-made-payment', 'I Made the Payment')}
                    />
            }
            {
                error && <Link
                    to={stringHelper.getLocalizedPath(currentLanguage, '/settings?tab=verify')}
                    className="form__note error">
                    *{error}
                </Link>
            }
        </div>
    )

}


export default AznDeposit
